import { TipoDocumento } from '@/js/common/enum';
import { Log } from '@/js/common/HIDebuggingSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';

import { useAppConfigStore } from '@/js/stores/appConfig';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useSettingRef } from '@erpagroapp/settings';

export default class CommonController {
  /**
   * Initializes the controller.
   */
  static async Initialize() {
    Log(this, this.Initialize.name);
    this.LoadUserProductionLineConfiguration(); // Las lineas de producción se utilizan en la mayoría de los procesos. Se decide cargar siempre.
  }

  /**
   * Realiza la carga de la entidad en ERP UsuarioLineaProduccion.
     Esta contiene las lineas de producción autorizadas para el usuario, sus puntos de volcado y puntos de paletizado relacionados.
   */
  static async LoadUserProductionLineConfiguration() {
    const appConfigStore = useAppConfigStore();

    const codeUser = appConfigStore.userLoginData.UserName;
    const response = await callExecuteSPERP(
      'APPERPAGRO_UsuarioLineaProduccionXUsuario',
      [{ NombreParametro: 'codigo', Valor: codeUser }],
      'Produccion.UsuarioLineaProduccionJSON',
    );
    if (response.status === 200) {
      const traceabilityStore = useTraceabilityStore();
      traceabilityStore.usuarioLineasProduccion = response.data;

      if (response.data.length > 0) {
        const selectedLine = response.data.find((f) => f.LineaPorDefecto);

        if (selectedLine) {
          const defaultProductionLine = useSettingRef('Volcado.LineaProduccionEstablecidaPorDefecto');
          const defaultDumpingPoint = useSettingRef('Volcado.PuntoVolcadoEstablecidoPorDefecto');

          defaultProductionLine.value = selectedLine.LineaProduccion;
          defaultDumpingPoint.value = selectedLine.PuntoVolcadoDefecto;
        }
      }
    }
  }

  /**
     Determina el tipo de documento a partir de un código de barras
    Para el caso de albaranes de compra, el formato del código de barras será el siguiente:
    10009IIIIIIC
    Siendo:
    10009 una cadena fija.
    IIIIIII el identificador del albarán de compra (AlbaranesCompra.id), completando con ceros por la izquierda hasta llegar a la longitud de 7 posiciones.
    C el dígito de control.
    Para el caso de pedidos de venta, el formato del código de barras será el siguiente:
    10010IIIIIIC
    Siendo:
    10010 una cadena fija.
    CASOS  DE USO:
   * APP06_Gestionar Ubicación Compras (reglas de negocio r1 y r2)
   *  APP07_Gestionar Ubicación Ventas (reglas de negocio r1 y r2)
   * @param {string} code
   * @returns {TipoDocumento} Enumerado con los posibles valores (ALBARAN_COMPRA, PEDIDO_VENTA, LISTA_UBICACION, LISTA_UBICACION_PREPARACION, PARTE_PRODUCCION)
   */
  static DeterminateBarCodeType(code) {
    let documentType;

    if (code?.length === 13) {
      if (code.startsWith('10009')) {
        documentType = TipoDocumento.ALBARAN_COMPRA;
      } else if (code.startsWith('10010')) {
        documentType = TipoDocumento.PEDIDO_VENTA;
      } else if (code.startsWith('10011')) {
        documentType = TipoDocumento.LISTA_UBICACION; // Location  List (ListaDeUbicaciones en ERP)
      } else if (code.startsWith('10012')) {
        documentType = TipoDocumento.LISTA_UBICACION_PREPARACION; // Picking List (ListaDeUbicacionesParaRecoleccion en ERP)
      } else if (code.startsWith('100040')) {
        documentType = TipoDocumento.PARTE_PRODUCCION; // Picking List
      }
    }

    return documentType || TipoDocumento.ND;
  }
}
